import {mapGetters, mapActions} from 'vuex';
import DownloadCsv from 'vue-json-csv';

// Constants
import * as APPOINTMENT from '@/store/constants/appointment';

// Mixins
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';
import AuthUser from '@/mixins/authenticated-user';

// Components
import SearchInput from '@/components/SearchInput';
import ListWithSpinner from '@/components/ListWithSpinner';
import TableRowActions from "@/components/TableRowActions";

export default {
  name: "AppointmentList",
  data() {
    return {
      fields: [
        {key: 'patient', sortable: true},
        {key: 'doctor', sortable: true},
        'primary_complaints',
        {key: 'appointment_date', sortable: true},
        'notes',
        'action'
      ],
      isProcessing: false
    }
  },
  mixins: [AuthUser, WithDateFilters, WithFilters],
  components: {
    SearchInput,
    ListWithSpinner,
    DownloadCsv,
    TableRowActions
  },
  computed: {
    ...mapGetters({
      appointments: APPOINTMENT.GET_APPOINTMENT_LIST
    }),

    items() {
      return this.appointments.data;
    },

    itemsForExport() {
      console.log(this.items, 'this.items');
      return window._.flatten(this.items);
    }
  },

  methods: {
    ...mapActions({
      listAppointments: APPOINTMENT.ACTION_LIST_APPOINTMENTS
    }),

    refreshData() {
      if (this.authUser.role.name === 'doctor') {
        this.setFilter({doctor: [`doctor_id,=,${this.authUser.doctor.id}`]});
      }

      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, wildcard: this.wildcard};
      }

      filters = {...filters, order_by: ['appointment_date,desc']};

      this.isProcessing = true;
      this.listAppointments(filters).finally(() => this.isProcessing = false);

      console.log(this.itemsForExport);
    },

    filterList: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`patient_name,like,${item}`] : null;
      this.refreshData();
    }, 1000),

    viewDetail(item) {
      this.$router.push(
        {
          name: 'AppointmentDetail',
          params: {id: item.id, appointment: item}
        }
      );
    },

    handleDateFilter(date) {
      this.setFilter({
        appointment_date_from: [`appointment_date,>=,${date.value.from}`],
        appointment_date_to: [`appointment_date,<=,${date.value.to}`]
      });

      this.refreshData();
    },

    handlePaginate() {
      this.refreshData();
    },

    init() {
      this.setDateFilterKeyField('appointment_date');
      this.initializeDateFilter();
      this.refreshData();
    }
  },

  mounted() {
    this.init();
    console.log(this.itemsForExport);
  }
}



// WEBPACK FOOTER //
// ./src/views/Appointment/js/appointment-list.js